var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketSlim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0429 11.1506C21.1839 9.00969 22.2532 6.02929 21.9491 3.05039C21.895 2.52017 21.4798 2.10502 20.9496 2.05091C17.9707 1.74685 14.9903 2.81614 12.8494 4.95706L10.8749 6.93154L9.63049 6.3179L9.09513 6.09247C8.10232 5.67442 6.94392 5.90769 6.17012 6.68149L4.13244 8.71917C3.90931 8.9423 3.97801 9.31615 4.26429 9.4367L5.84576 10.1026L7.09019 10.7163L6.71649 11.09C6.40032 11.4061 6.39567 11.9141 6.70612 12.2245L11.7755 17.2939C12.0859 17.6043 12.5939 17.5997 12.91 17.2835L13.2837 16.9098L13.8974 18.1542L14.5633 19.7357C14.6839 20.022 15.0577 20.0907 15.2808 19.8676L17.3185 17.8299C18.0923 17.0561 18.3256 15.8977 17.9075 14.9049L17.6821 14.3695L17.0685 13.1251L19.0429 11.1506Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04574 20.5618C9.31809 19.2895 9.31808 17.2266 8.04574 15.9543C6.7734 14.6819 4.71053 14.6819 3.43819 15.9543C2.57033 16.8221 2.17184 19.3643 2.00618 20.8929C1.93656 21.5353 2.46469 22.0634 3.10709 21.9938C4.63572 21.8282 7.17789 21.4297 8.04574 20.5618Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketSlim);
export default __webpack_public_path__ + "static/media/rocket-slim.05ab822521ae46c93ecf4ed06bce705b.svg";
export { ForwardRef as ReactComponent };